import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchAllProjects } from "../../../store/slices/projectsSlice";
import { setSelectedTabState } from '../../../store/slices/OperationSlices/operationStateSlice';
import { setAutoExpandAllTaskDetails, setSelectedProjectName, setSelectedTaskId } from '../../../store/slices/ProjectOngoing/taskScrollSlice';
import { useLoggedUser } from '../../../utils/useLoggedUser';

const formatHours = (value) =>
  new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  }).format(Number(value) || 0);

const UtilizationReport = ({
  User,
  ongoingProjectsManager1,
  ongoingProjectsManager,
  ongoingEntries1,
  ongoingEntries,
  isInteractionDisabled = false,
  onInteractionDisabled,
  isViewOnly = false,
}) => {
  const isCrmLocked = isInteractionDisabled && !isViewOnly;
  const handleRowClickWhenAllowed = (callback) => {
    if (isInteractionDisabled) {
      if (typeof onInteractionDisabled === "function") {
        onInteractionDisabled();
      }
    }
    callback();
  };

  const dispatch = useDispatch()
  const loggedUser = useLoggedUser();
  const ongoingWorkentries = useSelector((state) => state.operationFeature.ongoingWorkentries);
  const ongoingProjectsRedux = useSelector((state) => state.operationFeature.ongoingProjectsRedux);
  const [projectHoursArray, setProjectHoursArray] = useState([]);
  console.log("UtilizationReport ongoingWorkentries", ongoingWorkentries)
  console.log("UtilizationReport ongoingProjectsRedux", ongoingProjectsRedux)

  const projectsFromProps = ongoingProjectsManager1 ?? ongoingProjectsManager ?? [];
  const entriesFromProps = ongoingEntries1 ?? ongoingEntries ?? [];
  const projectOngoing = loggedUser?.EmpAuthLevel === "L4"
    ? ((Array.isArray(ongoingProjectsRedux) && ongoingProjectsRedux.length > 0) ? ongoingProjectsRedux : projectsFromProps)
    : projectsFromProps;
  const entriesOngoing = loggedUser?.EmpAuthLevel === "L4"
    ? ((Array.isArray(ongoingWorkentries) && ongoingWorkentries.length > 0) ? ongoingWorkentries : entriesFromProps)
    : entriesFromProps;
  console.log("UtilizationReport projectOngoing", projectOngoing)
  console.log("UtilizationReport entriesOngoing", entriesOngoing)
  console.log("UtilizationReport projectHoursArray", projectHoursArray)

  useEffect(() => {
    dispatch(fetchAllProjects())
  }, [dispatch])

  useEffect(() => {
    if (projectOngoing?.length > 0 && loggedUser?.EmpAuthLevel === "L4") {
    if(loggedUser?.customRoles?.includes("project manager")){

      const result = projectOngoing?.map((project) => {
        // Filter entries for the current project only
        const projectEntries = entriesOngoing?.filter(entry =>
          entry.projectid === project._id
        );
        const totalHoursSpent = projectEntries.reduce(
          (sum, entry) => sum + (entry.hoursspent || 0),
          0
        );
        const totalHoursAssigned = projectEntries.reduce(
          (sum, entry) => sum + (entry.hoursassigned || 0),
          0
        );
        const totalHours = totalHoursAssigned + totalHoursSpent
        const balancedHours = totalHoursAssigned - totalHoursSpent
        const overHours = Math.max(0, totalHoursSpent - totalHoursAssigned)

        return {
          projectId: project._id,
          selectedTaskEntry: projectEntries?.[0] || null,
          ProjectName: project.ProjectName,
          TotalHoursSpent: totalHoursSpent,
          TotalHoursAssigned: totalHoursAssigned,
          BalancedHours: Math.max(0, balancedHours), // Don't show negative balance
          OverHours: overHours,
          TotalHours: totalHours
        };
      });
      const onlyFifty = result?.slice(0, 50)
      setProjectHoursArray(onlyFifty);

    }else if(loggedUser?.customRoles?.includes("operations")){
      const result = projectOngoing?.map((project) => {
        // Filter entries for the current project only
        const empEntries = entriesOngoing?.filter((entry)=> entry?.taskownerid ===loggedUser?._id)
        const projectEntries = empEntries?.filter(entry =>
          entry.projectid === project._id
        );
        const totalHoursSpent = projectEntries.reduce(
          (sum, entry) => sum + (entry.hoursspent || 0),
          0
        );
        const totalHoursAssigned = projectEntries.reduce(
          (sum, entry) => sum + (entry.hoursassigned || 0),
          0
        );
        const totalHours = totalHoursAssigned + totalHoursSpent
        const balancedHours = totalHoursAssigned - totalHoursSpent
        const overHours = Math.max(0, totalHoursSpent - totalHoursAssigned)

        return {
          projectId: project._id,
          selectedTaskEntry: projectEntries?.[0] || null,
          ProjectName: project.ProjectName,
          TotalHoursSpent: totalHoursSpent,
          TotalHoursAssigned: totalHoursAssigned,
          BalancedHours: Math.max(0, balancedHours), // Don't show negative balance
          OverHours: overHours,
          TotalHours: totalHours
        };
      });
      const onlyFifty = result?.slice(0, 50)
      setProjectHoursArray(onlyFifty);
    }


    }
    else if (projectOngoing?.length > 0) {
      const projectGroups = projectOngoing?.reduce((acc, projectGroup) => {
        // Some backend payloads may not include `Projects` for every group.
        // Guard to avoid runtime "forEach of undefined" errors.
        (Array.isArray(projectGroup?.Projects) ? projectGroup.Projects : []).forEach((project) => {
          const projectName = project.ProjectName;
          if (!acc[projectName]) {
            acc[projectName] = {
              ProjectName: projectName,
              TotalHoursSpent: 0,
              TotalHoursAssigned: 0,
              BalancedHours: 0,
              OverHours: 0,
              TotalHours: 0,
              projectIds: [] // Track project IDs for this project name
            };
          }
          acc[projectName].projectIds.push(project._id);
        });

        return acc;
      }, {});

      Object.keys(projectGroups).forEach(projectName => {
        const projectGroup = projectGroups[projectName];

        const projectEntries = entriesOngoing?.filter(entry =>
          projectGroup.projectIds.includes(entry.projectid)
        );

        // Calculate totals
        projectGroup.TotalHoursSpent = projectEntries.reduce(
          (sum, entry) => sum + (entry.hoursspent || 0),
          0
        );
        projectGroup.TotalHoursAssigned = projectEntries.reduce(
          (sum, entry) => sum + (entry.hoursassigned || 0),
          0
        );

        projectGroup.TotalHours = projectGroup.TotalHoursAssigned + projectGroup.TotalHoursSpent;
        const balancedHours = projectGroup.TotalHoursAssigned - projectGroup.TotalHoursSpent;
        projectGroup.BalancedHours = Math.max(0, balancedHours);
        projectGroup.OverHours = Math.max(0, projectGroup.TotalHoursSpent - projectGroup.TotalHoursAssigned);
        projectGroup.selectedTaskEntry = projectEntries?.[0] || null;

        delete projectGroup.projectIds;
      });

      // Convert to array
      const result = Object.values(projectGroups);
      const onlyFifty = result?.slice(0, 50)

      setProjectHoursArray(onlyFifty);
    }
  }, [projectOngoing, entriesOngoing, User, loggedUser]);

  return (
    <div className=' bg-white rounded-md min-h-[22rem]'>
      <div className="p-3 ">
        {/* Header */}
        <div className="bg-[#e8e8e8] text-black border-x border-t border-b border-gray-400 text-center py-2 rounded-t-md shadow-md text-lg font-semibold min-w-[200px] overflow-auto ">
          Utilization Report
        </div>

        <div className="min-w-[200px] max-w-auto max-h-[18rem] overflow-auto p-0 border-l border-r border-gray-400" >
          <table className="min-w-[200px] overflow-y-auto max-w-auto overflow-auto table-fixed text-center border-r border-b border-gray-400">
            <thead className='sticky top-0 border-l border-r border-gray-400'>
              <tr className='text-xs '>
                <th className="bg-yellow-200 border border-r border-b border-gray-400 p-1  w-[17%] break-words whitespace-normal text-left">All Projects</th>
                <th className="bg-green-400 border border-r border-l border-b border-gray-400 p-1 w-[17%] break-words whitespace-normal text-left">Used Hours</th>
                <th className="bg-orange-300 border border-r border-l border-b border-gray-400 p-1 w-[17%] break-words whitespace-normal text-left">Balance Hours</th>
                <th className="bg-red-400 border border-r border-l border-b border-gray-400 p-1 w-[17%] break-words whitespace-normal text-left">Overhead</th>
              </tr>
            </thead>
            <tbody className='border-r border-gray-300'>
              {projectHoursArray?.length > 0 ? (
                projectHoursArray?.map((item, index) => (
                  <tr
                    onClick={() =>
                      handleRowClickWhenAllowed(() => {
                        dispatch(setSelectedTabState("projectOngoing"));
                        dispatch(setSelectedProjectName(item.ProjectName));
                        dispatch(setSelectedTaskId(item?.selectedTaskEntry || item?.projectId || item?.ProjectName));
                        dispatch(setAutoExpandAllTaskDetails(true));
                      })
                    }
                    key={index}
                    className={`text-xs ${isInteractionDisabled ? "cursor-default" : "cursor-pointer"}`}>
                    <td className=" border p-1 w-[8%] break-words whitespace-normal text-left">{item.ProjectName}</td>
                    <td className=" border p-1 w-[17%] break-all whitespace-normal text-center">
                      {isCrmLocked ? "🔒" : formatHours(item.TotalHoursSpent)}
                    </td>
                    <td className=" border p-1 w-[17%] break-all whitespace-normal text-center">
                      {isCrmLocked ? "🔒" : formatHours(item.BalancedHours)}
                    </td>
                    <td className=" border p-1 w-[17%] break-all whitespace-normal text-center">
                      {isCrmLocked ? "🔒" : formatHours(item.OverHours)}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center p-4 text-gray-400">
                    No projects found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default UtilizationReport